export default __webpack_public_path__ + "static/media/18t.4cf01113.jpg";